import React from 'react';

import FieldInput from '@magoosh/lib/formik_inputs/field_input';

import style from '@payments/style.module.scss';

interface UserFormGroupProps {
  handleBlur?: (e: any) => void;
}

export const UserFormGroup: React.FC<UserFormGroupProps> = ({
  handleBlur
}) => {
  return (
    <fieldset className="inputs">
      <div className="form-group">
        <FieldInput
          className={style.mediumStringInput}
          label="Email Address"
          name="email"
          type="input"
          onBlur={handleBlur}
        />
        <FieldInput
          className={style.mediumStringInput}
          label="Password"
          name="password"
          type="password"
          onBlur={handleBlur}
        />
        <FieldInput
          name="passwordConfirmation"
          type="password"
          label="Confirm Password"
          className={style.mediumStringInput}
          onBlur={handleBlur}
        />
      </div>
    </fieldset>
  );
};

export default UserFormGroup;
